import { Col, Row, Card } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./styles.css";
import { useRequiredAccess } from "../../hooks/useRequiredAccess";
import DownloadHistory from "./HistoryTable";
import { getApis } from "../Common/apis";
import {
  vehicleDetailsApiUrl,
  exportFileStatusUrl,
  exportHistoryUrl,
} from "../Common/endpoints";
import { setVehicleDetails } from "../../reducers/eolSlice";
import { useDispatch } from "react-redux";
import VehicleDetails from "../Dashboard/VehicleDetails";
import { ORG_TYPES } from "../Common/Constants";
import Filter from "./Filter";
import { setPageLoader } from "../../reducers/loaderSlice";

const ExportFile = () => {
  const dispatch = useDispatch();
  const [vehicle, setVehicle] = useState({});
  const [processingFiles, setProcessingFiles] = useState([]);
  const [historyDetails, setHistoryDetails] = useState({
    list: [],
    totalElements: 0,
  });
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 10,
  });
  const authToken = localStorage.getItem("authToken");

  const getVehicleDetails = useCallback(async () => {
    await getApis(
      vehicleDetailsApiUrl,
      {
        imei: vehicle?.vehImei,
      },
      authToken
    )
      .then((response) => {
        dispatch(setVehicleDetails(response?.data));
        dispatch(setPageLoader(null));
      })
      .catch((e) => {
        console.log(e.response?.data?.message);
        dispatch(setPageLoader(null));
      });

    // eslint-disable-next-line
  }, [authToken, dispatch, vehicle?.vehId]);

  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
    dispatch(setPageLoader("refresh"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vehicle?.vehId && vehicle?.vehId !== "") {
      dispatch(setPageLoader("refresh"));
      getVehicleDetails();
    }
  }, [getVehicleDetails, vehicle?.vehId, dispatch]);

  const onChangeVehicle = (_, options) => {
    setVehicle(options);
    dispatch(setVehicleDetails({}));
  };

  const getDownloadHistoryData = async () => {
    await getApis(
      exportHistoryUrl,
      {
        vIdVal: vehicle?.vehId,
        page: paginationDetails.current - 1,
        size: paginationDetails.pageSize,
        sort: "id,desc",
      },
      authToken
    )
      .then((res) => {
        if (res.status === 200) {
          setHistoryDetails({
            list: res?.data?.content,
            totalElements: res?.data?.totalElements,
          });
          const processingFileList = res?.data?.content?.map((file) =>
            file?.status === "PROCESSING" ? file.id : null
          );
          setProcessingFiles(processingFileList);
        }
      })
      .catch((e) => console.log(e));
  };

  useMemo(() => {
    if (vehicle?.vehId && vehicle?.vehImei !== "") {
      getDownloadHistoryData();
    }

    // eslint-disable-next-line
  }, [authToken, vehicle?.vehId, paginationDetails]);

  useEffect(() => {
    let intervalIds = [];

    const checkFileStatus = (fileId) => {
      getApis(exportFileStatusUrl, { requestId: fileId }, authToken)
        .then((response) => {
          if (response?.data && response.data.status !== "PROCESSING") {
            getDownloadHistoryData();
            clearInterval(intervalIds[fileId]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (processingFiles?.length > 0) {
      for (const fileId of processingFiles) {
        if (fileId && !intervalIds[fileId]) {
          intervalIds[fileId] = setInterval(
            () => checkFileStatus(fileId),
            20000
          );
        }
      }
    }

    return () => {
      for (const intervalId of intervalIds) {
        clearInterval(intervalId);
      }
    };
    // eslint-disable-next-line
  }, [processingFiles]);

  return (
    <div data-testid="export-file">
      <Row gutter={[16, 16]} className="export-page">
        <Col
          className="vehicle-dropdown"
          xs={24}
          sm={12}
          md={12}
          lg={12}
          xl={5}
        >
          <VehicleDetails onChangeImei={onChangeVehicle} imei={vehicle} />
        </Col>
        <Filter
          vehicle={vehicle}
          getDownloadHistoryData={getDownloadHistoryData}
        />
      </Row>
      <Row className="mt1 export-request-history">
        <Col span={24}>
          <Card title={"Request History"}>
            <DownloadHistory
              historyDetails={historyDetails}
              paginationDetails={paginationDetails}
              setPaginationDetails={setPaginationDetails}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ExportFile;
